import { UrlMatchResult, UrlSegment, UrlSegmentGroup } from '@angular/router';

enum SegmentParams {
  BASE_URL,
  QUERY,
  PAGE,
}

export function SearchRouteMatcher(segments: UrlSegment[], group: UrlSegmentGroup): UrlMatchResult | null {
  if (group.segments[0] && group.segments[SegmentParams.BASE_URL]?.path !== 'search') {
    return null;
  }
  const posParams: { [key: string]: UrlSegment } = {};

  if (segments[SegmentParams.QUERY]?.path.length >= 1) {
    posParams.query = segments[1];
  }

  if (segments[SegmentParams.PAGE]?.path === 'page' && segments?.[SegmentParams.PAGE]) {
    posParams.page = segments[3];
  }

  return {
    consumed: segments,
    posParams,
  };
}
